import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";


const StickyBar = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgba(211, 211, 211, 0.9);
  height: 4rem;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
  pointer-events: ${props => (props.isVisible ? "auto" : "none")};
  z-index: 2;
`;

const StickyFooter = ({
  children
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  return (
    <StickyBar isVisible={isVisible}>
      {children}
    </StickyBar>
  );
};

export default StickyFooter;